import { useEffect, useState } from 'react';
import { getQrCodeSvg } from 'services/api';
import { useAuth } from 'contexts/AuthContextProvider';
import { useNetworkCheck } from 'contexts/NetworkContextProvider';

export const useQrCodeSvg = (patientId: string, size: number = 160) => {
  const [qrCodeSvg, setQrCodeSvg] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { token } = useAuth();
  const { isOnline } = useNetworkCheck();

  useEffect(() => {
    let isMounted = true;

    // Avoid unauthorized QR requests when logged out/offline views are mounted.
    if (!patientId || !token || !isOnline) {
      setQrCodeSvg(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    // Assume fetchQrCodeSvg is the imported API method
    getQrCodeSvg(patientId, size)
      .then((svg: string) => {
        if (isMounted) {
          setQrCodeSvg(svg);
        }
      })
      .catch((err: any) => {
        if (isMounted) {
          setError('Failed to fetch QR code.');
          setQrCodeSvg(null);
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [patientId, size, token, isOnline]);

  return { qrCodeSvg, loading, error };
};
